import { render, staticRenderFns } from "./general-calendar.vue?vue&type=template&id=48b8922c&scoped=true&"
import script from "./general-calendar.vue?vue&type=script&lang=js&"
export * from "./general-calendar.vue?vue&type=script&lang=js&"
import style0 from "./general-calendar.vue?vue&type=style&index=0&id=48b8922c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b8922c",
  null
  
)

export default component.exports